/* eslint-disable no-unused-expressions */
import React, { useCallback, useEffect, useState } from "react";
import NormalInput from "component/common/NormalInput/index";
import ErrorMessage from "component/common/ErrroMessage/index";
import SaveCancelBtn from "component/common/SaveCancelBtn/index";
import CheckBox from "component/common/CheckBox/index";
import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { roleById, editRole } from "service/StaffsAndRoles";
import { Toast } from "utils/toast";
import usePopup from "hooks/usePopUp";
import arrow from "assets/images/arrow.svg";

import styles from "../AddRole/AddRole.module.scss";
import { getActionLists } from "service/Common";

const EditRole = () => {
  const history = useHistory();

  const { id } = useParams();

  const { successPopUp, togglePopUp, setMsg } = usePopup();

  let [role, setRole] = useState();

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    control,
    watch,
  } = useForm();

  let [actionLists, setActionLists] = useState([]);

  const checkbox = [
    "Dashboard",
    "Donations",
    "Directory",
    "Inventory",
    "Transactions",
    "Staffs & Roles",
    "Dispute",
  ];

  useEffect(() => {
    getRole();
    setMsg("Role details has been updated successfully");
  }, []);

  const getRole = async () => {
    try {
      let response = await roleById(id);

      const { accessible = [] } = response.data.data.result;

      const selectedModules = [];
      const tempData = accessible?.forEach(({ module, operation }) => {
        operation?.forEach((action) => {
          selectedModules.push(`${module}_${action}`);
        });
      });

      console.log(selectedModules);
      if (response.status == 200) {
        setRole(response.data.data.result);
        setValue("accessible", selectedModules);
      }
    } catch (error) {
      console.log(error);
      Toast({ type: "error", message: error?.data?.message });
    }
  };

  const onSubmit = async (data) => {
    const { accessible, name } = data || {};

    console.log(accessible);

    const selectedActions = accessible.reduce((prevData, currentData) => {
      console.log(currentData);
      const [currentModule, currentOp] = currentData?.split("_");

      const selectedModule = prevData?.findIndex(
        ({ module }) => module === currentModule
      );

      if (selectedModule !== -1) {
        prevData[selectedModule].operation.push(currentOp);
      } else {
        prevData.push({
          module: currentModule,
          operation: [currentOp],
        });
      }

      return prevData;
    }, []);

    const payload = {
      accessible: selectedActions,
      name,
    };
    try {
      let response = await editRole(payload, id);
      if (response.status == 200) {
        togglePopUp();
        setTimeout(() => {
          history.goBack();
        }, 2000);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handleCheckbox = (event) => {
    if (event.checked) {
      let newCheckbox = getValues("accessible");
      newCheckbox.push(event.value);

      // console.log(newCheckbox, );
      let data = { ...role, accessible: newCheckbox };
      setRole(data);
      setValue("accessible", newCheckbox);
      clearErrors("accessible");
    } else {
      let index = getValues("accessible").findIndex((list, index) => {
        return list === event.value;
      });
      let newCheckbox = getValues("accessible");
      newCheckbox.splice(index, 1);
      let data = { ...role, accessible: newCheckbox };
      setRole(data);

      setValue("accessible", newCheckbox);
    }
  };

  const getData = useCallback(async () => {
    try {
      let { data } = await getActionLists();

      const { result = [] } = data.data || {};

      const tempActionLists = result[0]?.actions || [];

      setActionLists(tempActionLists);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  if (role == null) return null;

  const accessible = watch("accessible");

  return (
    <>
      <div className={styles.addRole_title}>
        <img
          src={arrow}
          className="back-arrow"
          onClick={() => history.goBack()}
        />
        <b>Edit Role</b>
      </div>
      <div className={styles.addRole_box}>
        <div className="row">
          <div className="col-md-5">
            <NormalInput
              register={register("name", {
                required: true,
                pattern: /^[A-Za-z ]+$/,
                minLength: 3,
              })}
              label="Role Name"
              error={errors.name}
              value={role?.name}
            />
            <ErrorMessage
              error={errors.name}
              message={{
                required: "Please enter role name",
                minLength: "Role name contain atleast 3 characters",
                pattern: "Role name contain string only",
              }}
            />
          </div>
          <div className="col-md-12">
            <div className={styles.permission}>
              <Controller
                control={control}
                name="accessible"
                rules={{ required: true }}
                render={() => (
                  <label className={styles.title}>Permission</label>
                )}
              />
              <ErrorMessage
                error={errors.accessible}
                message={{
                  required: "Please select any one permission",
                }}
              />

              <div className="row mt-3">
                {actionLists?.map(({ module, operation = [] }) => (
                  <div className="col-12">
                    <p className="text-black fw-600">{`${module} Module`}</p>
                    <div className="row">
                      {operation.map((list, index) => {
                        return (
                          <div key={index} className="col-md-4 mt-4 mb-4">
                            <CheckBox
                              label={list}
                              value={`${module}_${list}`}
                              onChange={handleCheckbox}
                              isChecked={accessible?.includes(
                                `${module}_${list}`
                              )}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <SaveCancelBtn
              position="center"
              onSave={handleSubmit(onSubmit)}
              onCancel={() => history.goBack()}
            />
          </div>
        </div>
      </div>
      {successPopUp()}
    </>
  );
};

export default EditRole;
